module.exports = __webpack_public_path__ + "img/layout-left.79136406.svg";